var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"barcode-wrapper"},[(_vm.error)?_c('div',{staticClass:"error",domProps:{"textContent":_vm._s(_vm.error)}}):_c(_vm.tag,{ref:"barcode",tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }